<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar>
    <ion-title>
      <div>
        Produkte
      </div>
    </ion-title>
    <ion-buttons slot="start">
      <ion-back-button [text]="originPage"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="openProductForm()">
        <ion-icon slot="icon-only" name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  @if (productsSignal() && productsSignal().length > 0) {
  <ion-list class="safe-padding">
    <ion-item-divider sticky>
      <ion-label>
        {{ productsSignal()?.length }}
        {{ productsSignal()?.length === 1 ? "Produkt" : "Produkte" }}
      </ion-label>
    </ion-item-divider>
    <div slot="content">
      @for (product of productsSignal(); track product.product_id) {
        <ion-item-sliding>
          <ion-item (click)="productClicked(product)">
            <ion-label>
              <h3>{{product.name}}</h3>
              <p>{{product.unit}}</p>
            </ion-label>
            <ion-label class="ion-text-end">
              <p>{{product.prize | currency:'CHF':'symbol':'1.2-2'}}</p>
            </ion-label>
          </ion-item>
          <ion-item-options side="start">
            <ion-item-option color="danger" (click)="deleteProduct($event, product)" expandable>
              Löschen
            </ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      }
    </div>
  </ion-list>
}
  @if (!productsSignal() || productsSignal().length === 0) {
    <app-no-selection
      label="Keine Produkte"
      icon="cube-outline"
      color="medium"
      class="h-full"
  ></app-no-selection>
  }
</ion-content>